<template>
    <div class="card">
        <div v-if="!checkout"
            class="print-preview">
            <logo-horizontal></logo-horizontal>
            <div class="print-btn-top"
                style="display:none">
                <md-button class="md-raised md-primary"
                    @click="printReport">
                    <md-icon>print</md-icon>
                    {{ $t('general.print') }}
                </md-button>
            </div>
        </div>
        <div class="row"
            style="padding: 0 20px">
            <div class="col-lg-12 table-responsive">
                <table v-for="order in orders"
                    :key="order.order_id"
                    class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">
                                {{ $tc('orders.order', 1) }}
                            </th>
                            <th scope="col">
                                {{ $t('orders.order-status') }}
                            </th>
                            <th scope="col">
                                {{ $tc('orders.client', 1) }}
                            </th>
                            <th scope="col">
                                {{ $t('orders.shipping-date') }}
                            </th>
                            <th scope="col">
                                {{ $t('orders.delivery-date') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="row">
                                <span>{{ order.order_id }}</span>
                            </td>
                            <td>
                                <span style="text-transform:uppercase">
                                    {{ order.order_status }}
                                </span>
                            </td>
                            <td>
                                <span>{{ order.organization_name }} - {{ order.first_name }} {{ order.last_name }}</span>
                            </td>
                            <td>
                                <span>{{ order.shipped_date }}</span>
                            </td>
                            <td>
                                <span>{{ order.delivery_date }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6"
                                style="text-align:left;padding-left:5%">
                                <div class="row">
                                    <div class="col-lg-11 offset-lg-1 table-responsive">
                                        <br>
                                        <table class="table table-condensed table-sm">
                                            <thead>
                                                <tr>
                                                    <th scope="col"
                                                        style="width:12%">
                                                        {{ $tc('products.product', 2) }}
                                                    </th>
                                                    <th scope="col"
                                                        style="width:12%">
                                                        {{ $tc('products.quantity', 1) }}
                                                    </th>
                                                    <th scope="col"
                                                        style="width:12%">
                                                        {{ $tc('products.caliber', 1) }}
                                                    </th>
                                                    <th scope="col"
                                                        style="width:10%">
                                                        {{ $t('products.status') }}
                                                    </th>
                                                    <th scope="col"
                                                        style="width:10%">
                                                        {{ $t('products.preparation') }}
                                                    </th>
                                                    <th scope="col"
                                                        style="width:14%">
                                                        {{ $tc('products.item-status', 2) }}
                                                    </th>
                                                    <th scope="col"
                                                        style="width:30%">
                                                        {{ $tc('products.observation', 2) }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(product, index) in order.products"
                                                    :key="index">
                                                    <td>
                                                        <span style="text-transform:uppercase">{{ product.product_name }}</span>
                                                    </td>
                                                    <td>
                                                        <span>{{ product.quantity }} ({{ product.units }})</span>
                                                    </td>
                                                    <td>
                                                        <span>{{ product.caliber }}</span>
                                                    </td>
                                                    <td v-if="product.active">
                                                        <span>
                                                            {{ product.product_status }}
                                                        </span>
                                                    </td>
                                                    <td v-if="product.active">
                                                        <span>
                                                            {{ product.prepared === true ? $t('general.yes') : $t('general.no') }}
                                                        </span>
                                                    </td>
                                                    <td v-if="product.active">
                                                        <span>
                                                            {{ getOrderItemStatus(product.order_item_status_id) }}
                                                        </span>
                                                    </td>
                                                    <td v-if="product.active">
                                                        <span>
                                                            {{ product.notes }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <td colspan="4"
                            style="border-top:none;padding-left:5%">
                            <div class="row">
                                <div class="col-lg-11 offset-lg-1">
                                    <tr style="text-align:left">
                                        <td style="border-top:none">
                                            <p><strong>{{ $t('orders.order-notes') }}</strong></p>
                                        </td>
                                        <td colspan="3"
                                            style="border-top:none">
                                            <p>{{ order.description }}</p>
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </td>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import LogoHorizontal from '@/components/ui/LogoHorizontal.vue'
import luxon from '@/mixins/luxon'
import OrderStatus from '@/utils/orderStatus'

export default {
    name: 'PrintReport',

    mixins: [luxon],

    components: {
        LogoHorizontal
    },

    data () {
        return {
            orders: []
        }
    },

    methods: {
        getOrderItemStatus (id) {
            return OrderStatus.getOrderItemStatus(id)
        }
    },

    created () {
        this.orders = _.cloneDeep(window.data)

        setTimeout(function () {
            window.print()
            window.close()
        }, 0)
    }
}
</script>
